import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data?.data?.content?.map((item) => {
    return {
      amount: item?.settlementNetAmount,
      initiatedDate: dateFormatter(item?.created?.split(' ')?.[0], DateFormatTypes.MONTH_STRING_ISO),
      beneficiaryName: item?.legalName ?? item?.merchantId,
      status: item?.status,
      transactionMode: item?.transactionMode,
      settlementGrossAmount:item?.settlementGrossAmount,
      splitTxnIds: item?.payoutTransactionId,
    }
  })
}

const getSplitSettlementDetails = (req: any, tokens: any, userAccessToken: string) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.searchSettlementDetails,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      return error
    })
}

export { getSplitSettlementDetails }
